var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CanvasConnectedComponent } from "../generic/CanvasConnectedComponent";
var SceneManagerCanvas = /** @class */ (function (_super) {
    __extends(SceneManagerCanvas, _super);
    function SceneManagerCanvas() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldUpdate = function (_a, previousState) {
            var oldScene = _a.currentScene;
            return oldScene != undefined &&
                (!previousState ||
                    !previousState.currentScene ||
                    oldScene.sceneId !== previousState.currentScene.sceneId);
        };
        _this.update = function (_a) {
            var currentScene = _a.currentScene;
            if (_this.display != undefined) {
                _this.removeChild(_this.display);
                _this.display.destroy({
                    children: true,
                });
            }
            if (currentScene != undefined && currentScene.canvasComponent != undefined) {
                _this.display = new currentScene.canvasComponent(currentScene.config);
                _this.addChild(_this.display);
            }
        };
        _this.mapState = function (state) { return state.scenes; };
        _this.onChildrenChange = function (index) {
            _this.emit("child-added");
        };
        return _this;
    }
    return SceneManagerCanvas;
}(CanvasConnectedComponent));
export { SceneManagerCanvas };



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/SceneManagerCanvas.ts
// module id = 1682
// module chunks = 3